<template>
  <div
    v-if="loading !== 0 && loading !== false"
    class="m-block-loading"
  >
    <div class="m-block-loading-wrap">
      <Retry
        v-if="loading === -1"
        :message="message"
        :img-url="imgUrl"
        :retry-btn-text="retryBtnText"
        :is-page="isPage"
        @retry="fail"
      />

      <template v-else>
        <div class="m-icon-loading-container">
          <template v-if="isPage">
            <img
              src="~public/images/loading.svg"
              class="m-loading-img"
              alt="loading icon"
            >
          </template>
          <template v-else>
            <IconLoading />
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Retry from 'wap/components/Retry'
import IconLoading from 'fe-vui/IconLoading'

export default {
  name: 'Loading',
  components: {
    Retry,
    IconLoading
  },
  props: {
    loading: {
      type: [Boolean, Number],
      default: true
    },
    // 加载失败提示信息
    message: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: ''
    },
    // 重试按钮文案
    retryBtnText: {
      type: String,
      default: ''
    },
    isPage: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    fail() {
      this.$emit('fail')
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-block-loading {
  width: 100%;
  min-height: 166/@rem;

  .m-icon-loading-container {
    position: relative;
    height: 32/@rem;
    padding: 67/@rem 0;
    color: #999;
    text-align: center;
  }

  .m-icon-loading {
    width: 30/@rem;
    height: 30/@rem;
  }

  .m-loading-img {
    width: 50/@rem;
  }
}

</style>
